import React from "react";
import styled from "styled-components";

import * as Badge from "~/Badge";
import * as Color from "~/Color";
import * as Driver from "~/Driver";
import * as Layout from "~/Layout";
import * as Messaging from "~/Messaging";
import * as Typography from "~/Typography";

import { FilterState, TableData } from "../MessengerList";

export namespace Detail {
  export const Component: React.Fn<Messaging.Summary.DriverWithSummaries> = (
    messenger
  ) => {
    const rowSelected: boolean = Messaging.MessageInteraction.Active.isActive(
      messenger.driver
    );
    return (
      <Layout.Row.Component
        align="middle"
        justify="start"
        style={{
          backgroundColor: rowSelected ? Color.denseFog() : "inherit",
          padding: "0.7em",
          paddingBottom: "0.8em",
        }}
      >
        <Layout.Column.Component span={18}>
          <Layout.Block.Component>
            <Layout.Block.Component>
              <Driver.Name.Component {...messenger.driver} />
            </Layout.Block.Component>
            <Layout.Block.Component style={{ display: "flex" }}>
              <span
                style={{
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  display: "inline-block",
                  fontWeight: 300,
                  color: Color.steel(),
                  maxHeight: "30px",
                  paddingTop: "0.4em",
                  paddingBottom: "0.4em",
                }}
              >
                {messenger.summary && messenger.summary.mostRecentMessage}
              </span>
            </Layout.Block.Component>
          </Layout.Block.Component>
        </Layout.Column.Component>
        <Layout.Column.Component span={6}>
          <Layout.Row.Component align="middle" justify="end">
            <Layout.Column.Component span={20}>
              <Typography.Component align="right" style={{ width: "100%" }}>
                Recent Messages:
              </Typography.Component>
            </Layout.Column.Component>
            <Layout.Column.Component
              span={4}
              style={{
                justifySelf: "flex-end",
                height: "auto",
                minHeight: "0.5em",
              }}
            >
              {messenger.summary && messenger.summary.recentMessageCount > 0 ? (
                <Badge.Component
                  count={messenger.summary.recentMessageCount}
                  overflowCount={99}
                  badgeColor={Color.green()}
                  textColor={Color.white()}
                  className="recent-count"
                />
              ) : (
                <EmptyBadge.Component />
              )}
            </Layout.Column.Component>
          </Layout.Row.Component>
          {messenger.summary && messenger.summary.messageCount > 0 ? (
            <Layout.Row.Component align="middle" justify="end">
              <Layout.Column.Component span={20} style={{ height: "auto" }}>
                <Typography.Component align="right" style={{ width: "100%" }}>
                  Total Messages:
                </Typography.Component>
              </Layout.Column.Component>
              <Layout.Column.Component
                span={4}
                style={{ justifySelf: "flex-end", height: "auto" }}
              >
                <Badge.Component
                  count={messenger.summary.messageCount}
                  overflowCount={99}
                  badgeColor={Color.azure()}
                  textColor={Color.white()}
                  className="message-count"
                />
              </Layout.Column.Component>
            </Layout.Row.Component>
          ) : null}
        </Layout.Column.Component>
      </Layout.Row.Component>
    );
  };
}

export namespace Column {
  export const withRecentMessages = () => "with-recent";

  export const withMessages = () => "with-messages";

  export const column = (filterState: FilterState) =>
    ({
      title: "Driver",
      dataIndex: "messenger",
      key: "messenger",
      defaultSortOrder: "ascend",
      filters: [
        { text: "With Messages", value: withMessages() },
        {
          text: "With Recent Messages",
          value: withRecentMessages(),
        },
      ],
      filteredValue: filterState.messenger,
      filterMultiple: false,
      onFilter,
      sorter,
      render,
    } as const);

  const sorter = (a: TableData, b: TableData) =>
    Driver.compare(a.messenger.driver, b.messenger.driver);

  const render = (record: Messaging.Summary.DriverWithSummaries) => {
    return <Detail.Component {...record} />;
  };

  const onFilter = (filterValue: string, record: TableData) => {
    return (
      record.messenger.summary &&
      ((filterValue === "with-messages" &&
        record.messenger.summary.messageCount > 0) ||
        (filterValue === "with-recent" &&
          record.messenger.summary.recentMessageCount > 0))
    );
  };
}

export namespace EmptyBadge {
  export const Component: React.Fn = () => (
    <Wrapper>
      <BadgeInner>0</BadgeInner>
    </Wrapper>
  );

  const Wrapper = styled.span`
    display: inline-block;
    padding: 7px;
  `;

  const BadgeInner = styled.span`
    display: inline-block;
    text-align: center;
    line-height: 20px;
    min-width: 20px;
    height: 20px;
    border-radius: 10px;
    box-shadow: 0 0 0 1px ${Color.white()};
    background-color: ${Color.steel()};
    color: ${Color.white()};
  `;
}
